/* eslint-disable @next/next/no-img-element */
import {Button, Modal, ModalProps} from 'antd';
import classnames from 'classnames';
import useCommon from '@utils/hooks/common';
import styles from './styles';
import GradientButton from '@components/GradientButton';
import React from 'react';

export interface CustomPopupProps extends ModalProps {
  className?: any;
  children?: any;
  buttons?: {
    isBlue: boolean;
    loading?: boolean;
    buttonLabel: string;
    buttonFunction: Function;
    id?: string;
  }[];
  onBack?: () => void;
}

const CustomPopup = (props: CustomPopupProps) => {
  const {classes, t, theme} = useCommon({
    withTranslation: null,
    withStyles: styles,
  });

  const {className, children, buttons, onBack} = props;
  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';

  const renderButtons = () => {
    if (!buttons) return null;

    return buttons.map(button => (
      <GradientButton
        loading={button?.loading || false}
        isBlue={button?.isBlue}
        style={{height: 50, margin: 0, fontSize: 16, fontWeight: 600}}
        key={button.buttonLabel}
        id={button.id}
        className={classes.popupButton}
        onClick={() => {
          button.buttonFunction();
        }}
      >
        {button.buttonLabel}
      </GradientButton>
    ));
  };

  return (
    <Modal
      centered
      className={classnames(classes.customPopup, className)}
      styles={{
        mask: {
          backdropFilter: 'blur(2px)',
          background: 'rgba(0, 0, 0, 0.50)',
        },
        body: {
          padding: '10px 0 20px 0',
          ...props?.bodyStyle,
        },
      }}
      footer={renderButtons()}
      closeIcon={
        <img
          src="/icon/close-icon.svg"
          alt="close-button"
          style={{color: 'white', width: isDesktop ? 30 : 20}}
        />
      }
      {...props}
    >
      {onBack && (
        <Button className={classes.backIcon} type="text" onClick={onBack}>
          <img width={30} height={30} src="/icon/auth/arrowForward.svg" />
        </Button>
      )}
      {children}
    </Modal>
  );
};

export default React.memo(CustomPopup);
